import styled from 'styled-components';

export const StyledModularEnrolmentPage = styled.div`
    padding-bottom: 80px;
`;
